import { render } from "./ClaimApeModal.vue?vue&type=template&id=db644ba2"
import script from "./ClaimApeModal.vue?vue&type=script&lang=js"
export * from "./ClaimApeModal.vue?vue&type=script&lang=js"

import "./ClaimApeModal.vue?vue&type=style&index=0&id=db644ba2&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__